<template>
  <div>
    <div class="mt-2">
      <naj-search-box
        :type-id="formFieldType.number"
        :placeholder="local.home.tabCommon.filterWithJudgementCode"
        :search.sync="searchQuery.judgementCode"
        @filterDataClicked="filterData()"
        @showFilterClicked="toggleFilter()"
      ></naj-search-box>
    </div>
    <div
      v-if="hasFilter"
      class="filter-row-wrapper d-flex mt-3"
    >
      <div class="col-12">
        <template v-for="filter in filters">
          <span
            v-if="searchQuery[filter.name]"
            :key="filter.name"
            class="ma-1"
          >
            <v-chip
              :key="filter.name"
              :input-value="searchQuery[filter.name]"
              color="#F7FBFB"
              close
              outlined
              @click:close="searchQuery[filter.name]=null ; filterData();"
            >
              <strong class="text-primary">{{ filter.label + ':' + (searchQuery[filter.name+'DisplayName'] || searchQuery[filter.name]) }}</strong>
            </v-chip>
          </span>
        </template>
      </div>
    </div>

    <v-row class="mt-7">
      <v-col :cols="showFilter?9:12">
        <naj-item-table
          :data-items="data.list"
          :headers="headers"
          :pagination="pagination"
          :loading="loading"
          :items-per-page="20"
          :server-items-length="pagination.totalCount"
          @update:page="onPageChange"
        >
          <template
            slot="judgementCode"
            slot-scope="{item}"
          >
            <div class="info-item-details-title">
              {{ local.home.tabCommon.deedId }}
            </div>
            <div class="info-item-details-value mt-2">
              {{ item.judgementCode }}
            </div>
          </template>
          <template
            slot="actionSave"
            slot-scope="{item}"
          >
            <template>
              <v-app>
                <v-container>
                  <v-menu
                    offset-y
                    transition="scale-transition"
                    min-width="220px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        outlined
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ local.home.tabCommon.settings }}
                        <v-icon left>
                          mdi-dots-vertical
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item>
                        <v-list-item-title class="text-subtitle-2 grey--text">
                          {{ local.home.tabCommon.chooseSettings }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider></v-divider>

                      <v-list-item
                        link
                        @click="showJudgementDeliveryInfo(item)"
                      >
                        <v-list-item-icon>
                          <v-icon>mdi-file-document</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title> {{ local.home.tabCommon.viewRuling }}</v-list-item-title>
                      </v-list-item>

                      <v-list-item
                        v-if="item.hasRequest === true"
                        link
                        @click="$router.push({ path: `/cases/petition-requests/${item.judgementObjectKey}` })"
                      >
                        <v-list-item-icon>
                          <v-icon>mdi-file-sign</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ local.home.tabCommon.requests }}</v-list-item-title>
                      </v-list-item>

                      <v-list-item
                        v-if="item.isDestructive === true"
                        link
                        @click="showWaiverRequest(item)"
                      >
                        <v-list-item-icon>
                          <v-icon>mdi-file-export</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ local.home.tabCommon.requestsDesc }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-container>
              </v-app>
            </template>
          </template>
        </naj-item-table>
      </v-col>
      <v-col
        v-if="showFilter"
        cols="3"
      >
        <v-card color="pa-3">
          <v-row>
            <v-col class="pt-0">
              <div class="text-left">
                <v-icon
                  class="icon"
                  @click="toggleFilter()"
                >
                  mdi-close
                </v-icon>
              </div>
              <div class="text-h4 font-weight-bold">
                {{ local.common.filter }}
              </div>
            </v-col>
            <v-col
              v-for="filter in filters"
              :key="filter.name"
              cols="12"
            >
              <naj-input
                :type-id="filter.typeId"
                :label="filter.label"
                :value.sync="searchQuery[filter.name]"
                :value-name.sync="searchQuery[filter.name+'DisplayName']"
                :items="filter.items"
                item-text="name"
                item-value="id"
              ></naj-input>
            </v-col>

            <v-col
              cols="12"
              class="text-center"
            >
              <naj-button
                :loading="loading"
                @click="filterData()"
              >
                {{ local.common.filter }}
              </naj-button>

              <naj-button
                outlined
                @click="toggleFilter()"
              >
                {{ local.common.close }}
              </naj-button>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <judgement-delivery-info-modal
      :modal-visibility="showJudgementDeliveryInfoModal"
      :judgement="judgementToDeliver"
      @modalClose="hideJudgementDeliveryInfoModal"
    >
    </judgement-delivery-info-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapCasesActions } = createNamespacedHelpers('CasesModule');
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers(
  'LookupsModule'
);
import { toHijriDate } from '@/helpers/utils';
import { userType, judgementDeliveryStatus } from '@/helpers/enum';
import JudgementDeliveryInfoModal from '../judgement-delivery-info-modal';

export default {
  name: 'FinalJudgementsTab',
  components: { JudgementDeliveryInfoModal },
  props: {
    userInfo: {
      type: Object,
      required: true,
    },
    itemsPerPage: {
      default: 10,
      type: Number,
      required: false,
    },
    noDataText: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      showJudgementDeliveryInfoModal: false,
      selectedJudgement: {},
      judgementToDeliver: {},
      searchQuery: {
        judgementCode: null,
        criminalNumber: null,
        caseType: null,
      },
      showJudgementDeliveryConfirmationModal: false,
      loading: false,
      userType,
      showFilter: false,
      data: { list: [] },
      pagination: {
        pageSize: 20,
        pageIndex: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: false,
        hasNextPage: false,
      },
      headers: [
        {
          value: 'judgementCode',
          text: this.local.home.judgementDelivery.sakNumber,
          isCustomTemplate: false,
          class: 'judgementCode-header',
        },
        {
          value: 'casecode',
          text: this.local.home.judgementDelivery.casecode,
        },
        {
          value: 'criminalNo',
          text: this.local.home.judgementDelivery.criminalNumber,
        },
        {
          value: 'caseTypeName',
          text: this.local.home.judgementDelivery.caseTypeName,
        },
        {
          value: 'courtName',
          text: this.local.home.judgementDelivery.courtName,
        },
        {
          value: 'conclusiveDate',
          text: this.local.home.judgementDelivery.conclusiveDate,
          formatter: toHijriDate,
        },
        {
          value: 'deliveryStatus',
          text: this.local.home.judgementDelivery.deliveryStatusHeader,
        },
        {
          value: 'hasRequestString',
          text: this.local.home.judgementDelivery.petitionRequestsStatus,
        },
        {
          value: 'actionSave',
          class: 'action-item justify-content-center',
          isCustomTemplate: true,
        },
      ],
      judgementDeliveryStatus,
    };
  },
  computed: {
    ...mapLUTState(['criminalCaseTypes']),
    filters() {
      return [
        this.mapFilterItem('caseTypeId', 'caseType', 'selectbox', this.criminalCaseTypes),
        this.mapFilterItem('judgementCode', 'judgementCode', 'text'),
        this.mapFilterItem('criminalNumber', 'criminalNo', 'text'),
      ];
    },
    hasFilter() {
      return this.searchQuery.caseTypeId ||
        this.searchQuery.judgementCode ||
        this.searchQuery.criminalNo;
    },
    computedSearchQuery() {
      return Object.assign({}, this.searchQuery);
    },
  },
  watch: {
    computedSearchQuery: {
      deep: true,
      handler(newValue, oldValue) {
        const oldValueString = JSON.stringify({
          ...oldValue,
          judgementCode: null,
        });
        const newValueString = JSON.stringify({
          ...newValue,
          judgementCode: null,
        });
        const isChanged = oldValueString != newValueString;
        if (isChanged) {
          this.filterData();
        }
      },
    },
  },
  mounted() { this.init(); },
  methods: {
    ...mapLUTActions(['getCriminalCaseTypes']),
    mapFilterItem(name, key, typeId, items = []) {
      return {
        name: name,
        label: this.local.home.filter[key],
        typeId: this.formFieldType[typeId],
        items,
      };
    },
    showJudgementDeliveryInfo(item) {
      this.judgementToDeliver = item;
      this.showJudgementDeliveryInfoModal = true;
    },
    toggleFilter() {
      this.showFilter = !this.showFilter;
    },
    ...mapCasesActions(['getEmirateJudgements']),
    init() {
      this.loadData();
      this.getCriminalCaseTypes();
    },
    loadData() {
      this.loading = true;
      this.getEmirateJudgements({
        ...this.searchQuery,
        ...this.pagination,
      })
        .then(({ data }) => {
          this.loading = false;
          this.data = data;
          this.pagination = {
            pageIndex: data.pageIndex,
            pageSize: data.pageSize,
            totalCount: data.totalCount,
            totalPages: data.totalPages,
            hasPreviousPage: data.hasPreviousPage,
            hasNextPage: data.hasNextPage,
          };
        })
        .finally(() => {
          this.loading = false;
          this.$emit('updateTabCount', this.pagination.totalCount);
        });
    },
    filterData() {
      this.pagination.pageIndex = 0;
      this.loadData();
    },
    onPageChange(pageIndex) {
      this.pagination.pageIndex = pageIndex - 1;
      this.loadData();
    },
    hideJudgementDeliveryInfoModal() {
      this.getEmirateJudgements({
        ...{ judgementCode: this.selectedJudgement.judgementCode },
        ...this.pagination,
      })
        .then(({ data }) => {
          this.selectedJudgement = data.list[0];
          const index = this.data.list.findIndex((item) => {
            return (this.selectedJudgement.objectKey === item.objectKey);
          });
          this.data.list[index].judgementDeliveryStatusId = judgementDeliveryStatus.read;
          this.data.list[index].deliveryStatus = this.local.home.judgementDelivery.judgementRead;
          this.showDocumentsInfoModal = false;
          this.showJudgementDeliveryInfoModal = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    isDelivered(item) {
      return item.judgementDeliveryStatusId == judgementDeliveryStatus.read;
    },
    showWaiverRequest(item) {
      this.$router.push({ path: `/cases/waiver/${item.caseInfoObjectkey}/${item.judgementObjectKey}` });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .List__empty {
  margin-top: 0px !important;
}

::v-deep .info-item-box .info-item-details:nth-child(1) {
  background: var(--app-light-secondary-color) 0% 0% no-repeat padding-box;
}

.filter-row-wrapper {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 10px 30px #d1d5df80;
}

::v-deep .v-chip.v-chip--outlined.v-chip.v-chip {
  background-color: #f7fbfb !important;
  border: 1px solid var(--app-primary-color) !important;
  border-radius: unset;

  .v-chip__content {
    button {
      color: var(--app-primary-color);
    }
  }
}

::v-deep .info-item-details.judgementCode-header {
  .info-item-details-value {
    font-size: 24px;
  }
}
</style>